var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 82,
    viewBox: "0 0 103 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M730.5 102c1.772 0 3.236 1.22 3.468 2.804l.032.44V120h18.415c16.116 0 29.319 13.152 29.581 29.345l.004.491v4.328C782 170.58 768.694 184 752.415 184h-43.83C692.305 184 679 170.581 679 154.164v-4.328C679 133.42 692.306 120 708.585 120H727v-14.755c0-1.792 1.567-3.245 3.5-3.245zm-1.622 24.631h-20.293c-12.648 0-23.01 10.45-23.01 23.205v4.328c0 12.755 10.362 23.206 23.01 23.206h43.83c12.648 0 23.01-10.45 23.01-23.206v-4.328c0-12.755-10.362-23.206-23.01-23.206l-20.292.001c-.485.236-1.037.369-1.623.369-.585 0-1.137-.133-1.622-.369zM705.5 139c1.772 0 3.236 1.22 3.468 2.804l.032.44V148h5.755c1.792 0 3.245 1.567 3.245 3.5 0 1.772-1.22 3.236-2.805 3.468l-.44.032H709v5.755c0 1.792-1.567 3.245-3.5 3.245-1.772 0-3.236-1.22-3.468-2.804l-.032-.44V155h-5.755c-1.792 0-3.245-1.567-3.245-3.5 0-1.772 1.22-3.236 2.805-3.468l.44-.032H702v-5.755c0-1.792 1.567-3.245 3.5-3.245zm53.505 12c3.307 0 5.995 2.685 5.995 5.998 0 3.317-2.688 6.002-5.995 6.002-3.317 0-6.005-2.685-6.005-6.002 0-3.313 2.688-5.998 6.005-5.998zm-12.003-11c3.31 0 5.998 2.688 5.998 6 0 3.316-2.687 6-5.998 6-3.315 0-6.002-2.684-6.002-6 0-3.312 2.687-6 6.002-6z",
    transform: "translate(-813.000000, -2374.000000) translate(47.000000, 2272.000000) translate(87.000000, 0.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameIcon);
export default __webpack_public_path__ + "static/media/game-icon.6fcf4e93bf17a5ea00ffe3b7504f0d55.svg";
export { ForwardRef as ReactComponent };